import { useEffect, useState } from 'react';
import convertImageFormat from '../../../../utils/convertImageFormat';
import isSSR from '../../../../utils/isSSR';
const useConvertAndLoadImage = (imageSrc, skipLoadingImage = false) => {
    const [base64Image, setBase64Image] = useState('');
    const loadPNGImage = async (imageUrl) => {
        const result = await convertImageFormat(imageUrl, 'image/png');
        setBase64Image(result);
    };
    useEffect(() => {
        if (isSSR() || skipLoadingImage || !imageSrc)
            return;
        const { origin } = window.location;
        const fullImageUrl = origin + imageSrc;
        loadPNGImage(fullImageUrl);
    }, [imageSrc, skipLoadingImage]);
    return base64Image;
};
export default useConvertAndLoadImage;
